import CustomFormGroup from "../../../../components/form/CustomFormGroup";

const CryptoForm = ({ handleChange, updateAccountForm }) => {
  return (
    <>
      <CustomFormGroup
        label="ເຄື່ອຂາຍ"
        name="cryptoNetwork"
        onChange={handleChange}
        type="text"
        value={updateAccountForm.cryptoNetwork}
        placeholder="ເຄື່ອຂາຍ"
        required={true}
      />
      <CustomFormGroup
        name="cryptoAddress"
        label="ທີ່ຢູ່ Crypto"
        onChange={handleChange}
        value={updateAccountForm.cryptoAddress}
        type="text"
        placeholder="ທີ່ຢູ່ Crypto"
        required={true}
      />
    </>
  );
};

export default CryptoForm;
